module.exports = __webpack_public_path__ + "static/media/04.2ff4fbda.png";